import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { UserService } from 'app/core/user/user.service';
import { catchError, Observable, of, switchMap, throwError } from 'rxjs';

@Injectable({providedIn: 'root'})
export class AuthService
{
    private _authenticated: boolean = false;
    private _httpClient = inject(HttpClient);
    private _userService = inject(UserService);
_accessToken 

 private get apiUrl(): string {
    const base = localStorage.getItem('apiURL');
    if (!base) throw new Error('apiURL not ready');
    return base + "/api/v2" ;
  }
    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------
constructor(){
   this._accessToken = this.accessToken;
}
    /**
     * Setter & getter for access token
     */
    set accessToken(token: string)
    {
        localStorage.setItem('accessToken', token);
    }

    get accessToken(): string
    {
        return localStorage.getItem('accessToken') ?? '';
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Forgot password
     *
     * @param email
     */
    forgotPassword(email: string): Observable<any>
    {
        return this._httpClient.post('api/auth/forgot-password', email);
    }

    /**
     * Reset password
     *
     * @param password
     */
    resetPassword(password: string): Observable<any>
    {
        return this._httpClient.post('api/auth/reset-password', password);
    }

    /**
     * Sign in
     *
     * @param credentials
     */
    signIn(credentials: { email: string; password: string }): Observable<any>
    {
        // Throw error, if the user is already logged in
        if ( this._authenticated )
        {
            return throwError('User is already logged in.');
        }

        return this._httpClient.post(this.apiUrl+'/auth/login', credentials).pipe(
            switchMap((response: any) =>
            {
                console.log(response);
                // Store the access token in the local storage
                this.accessToken = response.access_token;

                // Set the authenticated flag to true
                this._authenticated = true;

                // Store the user on the user service
                this._userService.user = response.user;

                // Return a new observable with the response
                return of(response);
            }),
        );
    }

    /**
     * Sign in using the access token
     */
    signInUsingToken(): Observable<any>
    {
        // Sign in using the token
        return this._httpClient.post(this.apiUrl+'/auth/sign-in-with-token', {
            Access_Token: this.accessToken,
        }).pipe(
            catchError(() =>

                // Return false
                of(false),
            ),
            switchMap((response: any) =>
            {
                console.log("doneeeeeeeeeeeeeeeeeeee");
                // Replace the access token with the new one if it's available on
                // the response object.
                //
                // This is an added optional step for better security. Once you sign
                // in using the token, you should generate a new one on the server
                // side and attach it to the response object. Then the following
                // piece of code can replace the token with the refreshed one.
                if ( response.accessToken )
                {
                    this.accessToken = response.accessToken;
                }

                // Set the authenticated flag to true
                this._authenticated = true;

                // Store the user on the user service
                this._userService.user = response.user;

                // Return true
                return of(true);
            }),
        );
    }

    /**
     * Sign out
     */
    signOut(): Observable<any>
    {
        // Remove the access token from the local storage
        localStorage.removeItem('accessToken');

        // Set the authenticated flag to false
        this._authenticated = false;

        // Return the observable
        return of(true);
    }

    /**
     * Sign up
     *
     * @param user
     */
    signUp(user: { name: string; email: string; password: string; company: string }): Observable<any>
    {
        return this._httpClient.post('api/auth/sign-up', user);
    }

    /**
     * Unlock session
     *
     * @param credentials
     */
    unlockSession(credentials: { email: string; password: string }): Observable<any>
    {
        return this._httpClient.post('api/auth/unlock-session', credentials);
    }

    /**
     * Check the authentication status
     */
    /**
 * Check the authentication status
 */
// أضف هذه الدالة لفحص الـ token
private inspectToken(token: string): void {
    
    try {
        const parts = token.split('.');
        
        if (parts.length === 3) {
            const payload = JSON.parse(atob(parts[1]));
            
        }
    } catch (error) {
        console.error('🔍 - Error parsing token:', error);
    }
}

/**
 * Check the authentication status
 */

check(): Observable<boolean>
{
   
    if (this.accessToken) {
        this.inspectToken(this.accessToken);
    }
    // إذا كان المستخدم معتمداً بالفعل
    if (this._authenticated) {
        return of(true);
    }
    
    // إذا لم يكن هناك token
    if (!this.accessToken) {
        console.log('❌ Check: No access token');
        this._authenticated = false;
        return of(false);
    }
    
    // إذا كان token منتهي الصلاحية
    if (AuthUtils.isTokenExpired(this.accessToken)) {
        console.log('❌ Check: Token expired');
        this._authenticated = false;
        localStorage.removeItem('accessToken');
        return of(false);
    }
    
    console.log('🔄 Check: Attempting to authenticate with token');
    
    // إذا كان هناك token صالح، حاول المصادقة به
    return this.signInUsingToken().pipe(
        switchMap((result) => {
            console.log('🔑 SignInUsingToken result:', result);
            this._authenticated = result;
            return of(result);
        }),
        catchError((error) => {
            console.error('❌ SignInUsingToken error:', error);
            this._authenticated = false;
            return of(false);
        })
    );
}
}
